import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Root from "./App";
import reportWebVitals from "./reportWebVitals";
import i18n, { initI18n } from "./localization/LocalesConfig";


initI18n().then(() => {
  // only call changeLanguage AFTER init is done
  const lang = sessionStorage.getItem('preferredLanguage') || 'en';
  i18n.changeLanguage(lang); 
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<Root />);

})


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
